
// export default 'data:video/mp4;base64,video-focus-test';
import gif from './gif';
export default gif;
//# sourceMappingURL=mp4.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/media/mp4.js
// module id = 210
// module chunks = 0 1